import styled from 'styled-components';
export const FieldWrapper = styled.div `
  .csl-field {
    margin-bottom: ${(props) => `${props.extendMargin}px`};
    width: ${(props) => `${props.extendedWidth}%`};
  }
`;
//# sourceMappingURL=common.js.map